<template>
    <router-link :to="{ name: 'detailNews', params: { uid: item.uid }}" class="regular_card">
        <!-- Изображение новости -->
        <div class="image" v-if="image">
            <figure>
                <picture>
                    <img :data-src="image" class="lazyload" :alt="item.title" />
                </picture>
            </figure>
        </div>


        <!-- Контент новости -->
        <div class="news_body">
            <h4 class="news_title border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid">{{ item.title }}</h4>
            <div v-if="item.author_name" class="author">{{$t('author')}} {{item.author_name}}</div>
            <div class="flex items-center justify-between news_info">
                <div class="date">{{date}}</div>
                <vs-button size="small" type="border">{{$t('more')}}</vs-button>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: {
        item: Object
    },
    computed: {
        image() {
            // Проверяем есть ли изображение и если есть то возвращаем ключ с ссылкой на изображение
            if(this.item.front_image)
                return this.item.front_image.path
        },
        date() {
            // Выводим дату в нужном формате
            return this.$moment(this.item.pub_date).format('LL')
        }
    }
}
</script>

<style lang="scss" scoped>
.regular_card{
    display: flex;
    align-items: center;
    align-content: center;
    margin-bottom: 30px;
    width: 100%;
    background: #ffffff;
    padding: 15px;
    border-radius: 10px;
    color: #626262;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s,-webkit-transform .2s;
    &:hover{
        transform: translateY(-4px);
        box-shadow: 0 3px 10px 0 #ccc;
        transition: all .2s;
    }
    .news_body{
        width: 100%;
        h4{
            margin-bottom: 10px;
            padding-bottom: 10px;
        }
        .author{
            margin-bottom: 10px;
        }
    }
    .image{
        margin-right: 20px;
        figure{
            position: relative;
            width: 190px;
            padding-bottom: 85%;
            picture{
                position: absolute;
                background: rgba(0,0,0,.1);
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                overflow: hidden;
                border-radius: 10px;
                img{
                    width: 100%;
                    object-fit: cover;
                    vertical-align: middle;
                    -o-object-fit: cover;
                    height: 170px;
                    &.lazyload{
                        opacity: 0;
                    }
                }
            }
        }
    }
}
@media only screen and (max-width: 900px) {
    .regular_card{
        align-items: initial;
        margin-bottom: 10px;
        .news_title{
            font-size: 16px;
        }
        .author{
            font-size: 13px;
        }
        .date{
            font-size: 13px;
        }
        .news_info{
            flex-wrap: wrap;
            .date{
                width: 100%;
                margin-bottom: 10px;
            }
        }
        .image{
            figure{
                width: 70px;

            }
        }
    }
}
</style>
